import React from "react";
import "./Footer.css";
import { Link } from "react-router-dom";
// import FooterFrame from "../../Assets/Svg/FooterFrame.svg";
import FooterLogo from "../../Assets/Svg/FooterLogo.svg";
import FacebookIcon from "../../Assets/Svg/FaceIconWhite.svg";
// import LinkedInIcon from "../../Assets/Svg/LinkedIconWhite.svg";
import InstagramIcon from "../../Assets/Svg/InstaIconWhite.svg";
import WhatsApp from "../../Assets/Svg/Whatsapp.svg";

export default function ArabicFooterMobile() {
  return (
    <div className="Footer_Container Footer_Container_Mob">
      {/* footer part one */}
      <div className="Footer_P1">
        <img src={FooterLogo} alt="FooterLogo" className="FooterLogo" />

        <h3 className="Footer_P1_H3 ar" dir="rtl">
          اجعل فريق عملك متميز <br /> تواصل معنا اليوم!
        </h3>
      </div>
      {/* footer part two */}
      <div className="Footer_P2 ar">
        <Link to="/contact-us/ar">اتصل بنا</Link>
        <Link to="/media/ar">المعرض</Link>
        <Link to="/categories/ar">الفئات</Link>
        <Link to="/about-us/ar">من نحن</Link>
        <Link to="/">الصفحة الرئيسية</Link>
      </div>
      {/* footer part three */}
      <div className="Footer_P3 Footer_P3_Mob">
        <a href="https://www.facebook.com/uniformarena" target="_blank" rel="noopener noreferrer">
          <img src={FacebookIcon} alt="FacebookIcon" className="FacebookIconFooter" />
        </a>
        {/* <a href="https://www.linkedin.com/company/uniformarena" target="_blank" rel="noopener noreferrer">
          <img src={LinkedInIcon} alt="LinkedInIcon" />
        </a> */}
        <a href="https://www.instagram.com/uniformarena/" target="_blank" rel="noopener noreferrer">
          <img src={InstagramIcon} alt="InstagramIcon" />
        </a>
        <a href="https://wa.me/97433222436" target="_blank" rel="noopener noreferrer">
          <img src={WhatsApp} alt="InstagramIcon" />
        </a>
      </div>
      {/* footer part four */}
      <div>
        <h3 className="Footer_P4_H3 Footer_P4_H3_Mob_Ar" dir="rtl">
          يحتفظ يونيفورم ارينا بكل حقوق النشر ©2025
        </h3>
      </div>
    </div>
  );
}
